import React from 'react';
import PropTypes from 'prop-types';
import Badge from '../../Badge';
import { numberFormatter } from '../../../../utils/number';

// The settlement difference cannot be negative. Any overpayment is reported separately as surplus, while shared deposits are not considered surplus.
const BankReconciliationSurplusCell = ({
  value,
  surplus,
  sharedDepositCount,
  showSurplus,
}) => (
  <span>
    {numberFormatter({ value })}
    {sharedDepositCount > 0 ? (
      <Badge
        color="light"
        className="ml-1"
        text="compartido"
        title="El depósito cubre más de una liquidación y se muestra completo en cada una. El exceso no es un sobrante: es la parte que cubre a la otra liquidación. En el total se cuenta una sola vez."
      />
    ) : null}
    {showSurplus && surplus > 0 ? (
      <Badge
        color="info"
        className="ml-1"
        text={`sobrante ${numberFormatter({ value: surplus })}`}
        title="Se depositó más de lo que había que depositar. El sobrante no se resta de la diferencia ni se imputa a otra liquidación."
      />
    ) : null}
  </span>
);

BankReconciliationSurplusCell.propTypes = {
  value: PropTypes.number.isRequired,
  surplus: PropTypes.number,
  sharedDepositCount: PropTypes.number,
  showSurplus: PropTypes.bool,
};

BankReconciliationSurplusCell.defaultProps = {
  surplus: 0,
  sharedDepositCount: 0,
  showSurplus: false,
};

export default BankReconciliationSurplusCell;
